<template>
  <Head :title="__('balance.giffy-purchases.title')" />

  <Breadcrumbs
    :pages="[
      { name: __('balance.overview.title'), href: route('frontend.balance') },
    ]"
    :current-page="__('balance.giffy-purchases.title')"
  />

  <section class="container mb-6 md:mb-4">
    <h1 class="text-2xl md:text-3xl font-bold mb-4 md:mb-2.5">
      {{ __('balance.giffy-purchases.title') }}
    </h1>
  </section>
  <section class="container mb-6">
    <div class="w-full bg-white mb-6 rounded-l shadow p-4 divide-solid divide-y">
      <div class="flex flex-wrap mt-2 mb-2 md:text-black text-xs md:text-sm font-bold w-full">
        <div class="w-4/12 md:w-8/12">
          {{ __('balance.description') }}
        </div>
        <div class="w-4/12 md:w-2/12 pl-3 text-right">
          {{ __('balance.date') }}
        </div>
        <div class="w-4/12 md:w-2/12 pl-3 text-right">
          {{ __('balance.qoins') }}
        </div>
      </div>
      <template v-if="balanceMutations.meta.pagination.total > 0">
        <div
          v-for="balanceMutation in balanceMutations.data"
          :key="balanceMutation.id"
          class="py-2"
        >
          <div class="flex w-full mb-1 text-sm md:text-base">
            <div class="w-4/12 md:w-8/12">
              {{ balanceMutation.name }}
            </div>
            <div class="w-4/12 md:w-2/12 pl-3 text-right">
              {{ balanceMutation.date }}
            </div>
            <div class="w-4/12 md:w-2/12 pl-3 text-right">
              {{ balanceMutation.value }}
            </div>
          </div>
        </div>
      </template>

      <p
        v-else
        class="text-sm md:text-base text-center py-2"
      >
        {{ __('balance.giffy-purchases.no-data') }}
      </p>

      <div
        v-if="balanceMutations.meta.pagination.links.length > 3"
        class="pt-4"
      >
        <Pagination :pagination="balanceMutations.meta.pagination" />
      </div>
    </div>
  </section>
  <Faq :faq-items="faqItems" />
</template>

<script>
import Breadcrumbs from '../../Components/Breadcrumbs.vue';
import Pagination from '../../Components/Pagination.vue';
import Faq from './Components/Faq.vue';

export default {
  components: {
    Faq,
    Breadcrumbs,
    Pagination,
  },

  props: {
    balanceMutations: {
      type: Object,
      required: true,
    },

    faqItems: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

};
</script>
